import * as React from "react";
import { forwardRef } from "react";
const SvgCaretDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 12 8",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "m11 .5-5 5-5-5-1 1 6 6 6-6-1-1Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgCaretDown);
export default ForwardRef;
